import { Button, Grid, Paper } from "@mui/material";
import React, { useEffect, useState } from "react";
import "../../Styles/strategy.css";
import HeaderIcons from "../../Images/headericon.png";
import AddUserPopup from "../../Modals/AddUserPopup";
import { useDispatch, useSelector } from "react-redux";
import {
  GetUserInfo,
  GetApiPermission,
} from "../../redux/Actions/userStatusService";
import Roles from '../Tables/Roles'

function AddUserManagment() {
  const [openAddUser, setOpenAddUser] = useState(false);

  const type= localStorage.getItem("type")
  const { userInformation, userPermissions } = useSelector(
    (state) => state.userStatus
  );

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(GetUserInfo({type:type}));
    dispatch(GetApiPermission(type));
  }, []);
  return (
    <>
      <Grid item xs={12} sx={{mt:10}}>
        <Paper
          sx={{ p: 2, display: "flex", flexDirection: "column" }}
          elevation={1}
        >
          <div className="row rows" style={{ marginLeft: "2px" }}>
            <div className="col-1">
              <img src={HeaderIcons} alt="Header Icon" width="45" height="45" />
            </div>
            <div
              className="col-10"
              style={{ marginTop: "10px", marginLeft: "-3%" }}
            >
              <p style={{ fontSize: "20px", color: "#18275A" }}>
                {" "}
                Add Role Management
              </p>
            </div>
            <div
              className="col-1"
              style={{ marginTop: "10px", marginLeft: "-3%" }}
            >
              <Button
                sx={{ width: "120px" }}
                variant="contained"
                onClick={() => {
                  setOpenAddUser(true);
                }}
              >
                Add Manager
              </Button>
            </div>
          </div>
        </Paper>
      </Grid>
      <div
        style={{
          height: "calc(100vh - 100px)",
          overflowY: "auto",
          overflowX: "hidden",
          marginTop: "25px",
        }}
      >
        <Grid item xs={12}>
          <div className="row">
            <div className="col-12">
              <Roles portal={type}/>
            </div>
          </div>
        </Grid>
      </div>
      <AddUserPopup
        open={openAddUser}
        onClose={() => setOpenAddUser(false)}
        portal={type}
        userInformation={userInformation}
        userPermissions={userPermissions}
      />
    </>
  );
}

export default AddUserManagment;
